import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const ContentAuthoringApi = createApi({
  reducerPath: "contentAuthoringAPi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getContentModifieds: builder.query({
      query: () => {
        return {
          url: `/proxy/content-modifieds`,
          method: "GET"
        };
      },
      extraOptions: { service: "Strapi" }
    }),
    postContentModifieds: builder.mutation({
      query: (data) => {
        console.log("data", data);
        const contentData = {
          data: data
        };
        return {
          url: `/content/create`,
          headers: {
            // Authorization: `${import.meta.env.VITE_STRAPI_TOKEN}`,
            service: "LP_Authoring"
          },
          method: "POST",
          body: contentData
        };
      },
      extraOptions: { service: "LP_Authoring" }
    }),
    putContentModifieds: builder.mutation({
      query: (data) => {
        const contentData = {
          data: data
        };
        return {
          url: `/content/update`,
          headers: {
            service: "LP_Authoring"
          },
          method: "PUT",
          body: contentData
        };
      },
      extraOptions: { service: "LP_Authoring" }
    }),
    putContentModifiedsByPkid: builder.mutation({
      query: (data) => {
        console.log("data", data);
        const contentData = {
          data: data
        };
        return {
          url: `/content/update`,
          headers: {
            service: "LP_Authoring"
          },
          method: "PUT",
          body: contentData
        };
      },
      extraOptions: { service: "LP_Authoring" }
    }),
    updateContent: builder.mutation({
      query: (data) => {
        const contentData = {
          data: data
        };
        return {
          url: `/content/update`,
          headers: {
            Authorization: `${import.meta.env.VITE_STRAPI_TOKEN}`,
            service: "strapi"
          },
          method: "Post",
          body: contentData
        };
      },
      extraOptions: { service: "Content_Validate" }
    }),
    getContentModifiedsById: builder.query({
      query: (contentId) => {
        return {
          url: `/content/get/${contentId}`,
          headers: {
            service: "LP_Authoring"
          },
          method: "GET"
        };
      },
      extraOptions: { service: "LP_Authoring" }
    }),
    validateContent: builder.query({
      query: (contentId) => {
        // console.log("contentId from slice", contentId);
        return {
          url: `/content/validate/${contentId}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Content_Validate" }
    }),
    validateEditContent: builder.query({
      query: ({ contentId, isPublished }) => {
        return {
          url: `/content/validate/${contentId}/${isPublished}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Content_Validate" }
    }),
    contentUpdate: builder.mutation({
      query: ({ contentId, status, remarks }: any) => {
        return {
          url: `/content/status/${contentId}`,
          method: "POST",
          body: {
            status: status,
            remarks: remarks
          },
          headers: {
            Authorization: `${import.meta.env.VITE_STRAPI_TOKEN}`,
            service: "strapi"
          }
        };
      },
      extraOptions: { service: "Content_Validate" }
    }),
    initiateCmi5Upload: builder.query({
      query: ({ contentId, assetId }: any) => {
        return {
          url: `/scorm/initiate/upload/${contentId}/${assetId}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Cmi5_Authoring" }
    }),
    getCmi5UploadStatus: builder.query({
      query: (contentId) => {
        return {
          url: `/scorm/upload/status/${contentId}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Cmi5_Authoring" }
    })
  })
});

export const {
  useGetContentModifiedsQuery,
  usePostContentModifiedsMutation,
  useGetContentModifiedsByIdQuery,
  useLazyGetContentModifiedsByIdQuery,
  usePutContentModifiedsMutation,
  usePutContentModifiedsByPkidMutation,
  useUpdateContentMutation,
  useLazyValidateContentQuery,
  useLazyValidateEditContentQuery,
  useContentUpdateMutation,
  useLazyInitiateCmi5UploadQuery,
  useLazyGetCmi5UploadStatusQuery
} = ContentAuthoringApi;
